import { render, staticRenderFns } from "./collection-history.vue?vue&type=template&id=48fbcd59&scoped=true"
import script from "./collection-history.vue?vue&type=script&lang=ts"
export * from "./collection-history.vue?vue&type=script&lang=ts"
import style0 from "./collection-history.vue?vue&type=style&index=0&id=48fbcd59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fbcd59",
  null
  
)

export default component.exports